export enum NetworkType {
  NoWallbox,
  SteadyPower,
  MasterSlave,
  PowerManagementEnabled,
}
